import React from 'react';
export function EmotionalTransition() {
  return <section className="py-20 px-4 bg-blue-900 text-center" data-id="element-58">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-59">
        <p className="text-xl md:text-2xl text-blue-100 leading-relaxed" data-id="element-60">
          Sappiamo quanto sia frustrante passare ore in cucina per un risultato
          deludente. Hai seguito la ricetta alla lettera, ma il plumcake non è
          venuto come speravi.
        </p>

        <p className="text-2xl md:text-3xl text-white font-bold leading-tight" data-id="element-61">
          Ma la verità è questa: I migliori plumcake sono i più semplici...
          quando conosci la tecnica giusta.
        </p>

        <p className="text-xl text-blue-200" data-id="element-62">
          E noi vogliamo insegnarti esattamente questo.
        </p>
      </div>
    </section>;
}